var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnEmailTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4728_21507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.34 17.1556C15.6434 17.62 14.8343 17.8655 14 17.8655C13.1658 17.8655 12.3566 17.62 11.66 17.1556L0.18643 9.50626C0.122773 9.46382 0.0607578 9.41958 0 9.37408V21.9083C0 23.3454 1.16621 24.4859 2.57759 24.4859H25.4224C26.8594 24.4859 27.9999 23.3197 27.9999 21.9083V9.37402C27.9391 9.41963 27.877 9.46399 27.8131 9.50648L16.34 17.1556Z",
    fill: "#FFBD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09648 8.14077L12.5701 15.7901C13.0044 16.0797 13.5022 16.2245 13.9999 16.2245C14.4978 16.2245 14.9956 16.0796 15.4299 15.7901L26.9035 8.14077C27.5901 7.68331 28 6.91769 28 6.09136C28 4.67052 26.8441 3.51465 25.4233 3.51465H2.57671C1.15593 3.5147 0 4.67058 0 6.09273C0 6.91769 0.409937 7.68331 1.09648 8.14077Z",
    fill: "#FFBD05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4728_21507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmailTheme);
export default __webpack_public_path__ + "static/media/icn_email_theme.6c6b7fff3581b02563484532622d1a49.svg";
export { ForwardRef as ReactComponent };